import { getApi } from "../../services/httpService";


export function managementInfo(){
    return getApi().get('home/managementInfo');
}